import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { SubmissionError } from 'redux-form';
import { withRouter } from 'react-router-dom';
import Button from 'components/buttons/Button';
import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import { urlAccountById } from 'constants/apiRouting';
import { isEmpty } from 'lodash';

import { createAccount } from 'redux/actions/accountActions';
import AccountForm from './AccountForm';

class AccountCreate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    createAccount: PropTypes.func.isRequired,
    account: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    organizations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })).isRequired,
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  async onSubmit(formData) {
    try {
      await this.props.createAccount({
        name: formData.accountName,
        email: formData.email,
        products: formData.selectedProducts ? formData.selectedProducts.map(product => ({ name: product.name })) : [],
        industries: formData.selectedIndustryTags && formData.selectedIndustryTags.map(l => (l.value)),
        organization: !isEmpty(formData.selectedOrganization) ?
          formData.selectedOrganization.value :
          this.props.organizations[0].id,
        accepts_sponsorships: formData.acceptsSponsorships,
      });
      // Check if account was created and account.id exists.
      if (this.props.account.id) {
        this.props.history.push(urlAccountById(this.props.account.id));
      }
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <div className={this.props.className}>
        <Button
          color="primary"
          variant="contained"
          size="large"
          onClick={this.toggle}
          startIcon={<PlusCircleOutlineIcon />}
          data-intercom-target="Add account button"
        >
          Add account
        </Button>
        <Dialog
          open={this.state.isOpen}
          onBackdropClick={this.toggle}
          PaperProps={{
            'data-intercom-target': 'Add account dialog',
          }}
        >
          <DialogTitle disableTypography>Add Account</DialogTitle>
          <AccountForm toggleModal={this.toggle} onSubmit={data => this.onSubmit(data)} />
        </Dialog>
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(
    state => ({
      account: state.account,
      organizations: state.user.organizations,
    }),
    { createAccount },
  ),
  withNamespaces('common'),
)(AccountCreate);
